<section class="row m-0">
	<form #costCenterForm="ngForm" class="col-24 px-0" (ngSubmit)="onSave()">
		<ng-container *ngIf="!useFallback">
			<ng-container *ngFor="let dimension of dimensionConfig">
				<kee-combobox
					[name]="'dimension_' + dimension.dimensionId"
					class="col-24 no-clear-value"
					[label]="dimension.dimensionName" [labelOnTop]="true"
					[data]="filteredDimensionValues[dimension.dimensionId]"
					valueField="code" textField="fullName" [valuePrimitive]="true"
					[(ngModel)]="dimensionValues[dimension.dimensionId]"
					[suggest]="true" [showClearButton]="true"
					[filterable]="true" (filterChange)="handleDimensionFilter(dimension, $event)"
					(close)="resetDimensionFilter(dimension)"
					[popupSettings]="{width:'auto'}"
					required>
					<ng-template kendoComboBoxItemTemplate let-dataItem>
						<span class="template">{{ dataItem.code }}&nbsp;-&nbsp;{{ dataItem.name }}</span>
					</ng-template>
				</kee-combobox>
			</ng-container>
		</ng-container>
		<ng-container *ngIf="useFallback">
			<inputfield name="costCenter" label="Centru de cost"
				[(ngModel)]="fallbackCostCenter" required>
			</inputfield>
		</ng-container>
		<div class="divider col-24 p-0 mt-1 mb-4"></div>
		<div class="col-24 d-flex justify-content-around">
			<button class="btn btn-primary waves-effect waves-light" type="submit">
				<i class="mdi-content-save mr-2"></i>
				<span>Salvează</span>
			</button>
			<button class="btn waves-effect waves-light" type="button" (click)="close.emit()">
				<i class="mdi-content-clear mr-2"></i>
				<span>Renunță</span>
			</button>
		</div>
	</form>
</section>
